"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_dom_1 = __importDefault(require("react-dom"));
const react_1 = __importDefault(require("react"));
const react_tooltip_1 = require("react-tooltip");
/* A simple wrapper around ReactTooltip to render tooltips into a portal */
const MlcTooltip = (props) => {
    const tooltipRoot = document.getElementById('tooltip-root');
    return tooltipRoot ? react_dom_1.default.createPortal(react_1.default.createElement(react_tooltip_1.Tooltip, Object.assign({}, props)), tooltipRoot) : null;
};
exports.default = MlcTooltip;
